import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";
import { Clock, ClipboardCheck, Wrench, ShoppingCart, CalendarDays, FileText, Languages, LogOut, CalendarCheck } from "lucide-react";

const TASKS_BY_ROLE = { housekeeping: "/field-ops/housekeeping", maintenance: "/maintenance/my", gardener: "/maintenance/my", fnb: "/stock-count/staff?dept=fnb", concierge: "/supply-order", employee: "/field-ops" };

export default function StaffHome() {
  const { user, logout } = useAuth();
  const { lang, toggle } = useLang();
  const el = lang === "el";
  const can = (to) => (user?.permissions?.[to.split("?")[0]] ?? "-") !== "-";
  const tiles = [
    { to: "/team/timeclock", icon: Clock, el: "Χτύπα κάρτα", en: "Clock in / out", color: "bg-[#45423C]" },
    { to: TASKS_BY_ROLE[user?.role] || "/field-ops", icon: ClipboardCheck, el: "Οι δουλειές μου σήμερα", en: "My jobs today", color: "bg-[#6E7A63]" },
    { to: "/maintenance/new", icon: Wrench, el: "Δήλωσε βλάβη", en: "Report an issue", color: "bg-[#C86235]" },
    { to: "/supply-order", icon: ShoppingCart, el: "Χρειάζομαι υλικά", en: "I need supplies", color: "bg-[#2E6F7A]" },
    { to: "/schedule", icon: CalendarDays, el: "Πρόγραμμα & άδειες", en: "Schedule & leave", color: "bg-[#8A7DAE]" },
  ].filter((t) => can(t.to));
  return (
    <div className="max-w-md mx-auto space-y-5" data-testid="staff-home">
      <div>
        <p className="text-sm font-mono uppercase tracking-widest text-[#C86235]">{el ? "Καλώς ήρθες" : "Welcome"}</p>
        <h1 className="font-serif text-4xl text-[#45423C]">{user?.name}</h1>
      </div>
      <div className="grid grid-cols-1 gap-3">
        {tiles.map((t) => (
          <Link key={t.to} to={t.to} data-testid={`staff-tile-${t.to.split("?")[0]}`}
            className={`${t.color} text-white rounded-2xl px-5 py-6 flex items-center gap-4 shadow-sm active:scale-[0.98] transition-transform`}>
            <t.icon className="h-9 w-9 shrink-0" />
            <span className="text-xl font-semibold leading-tight">{el ? t.el : t.en}</span>
          </Link>
        ))}
      </div>
      <div className="rounded-2xl bg-white border border-[#E3DED4] divide-y divide-[#E3DED4]" data-testid="staff-profile-menu">
        {can("/leave") && <Link to="/leave" data-testid="staff-leave" className="flex items-center gap-3 px-5 py-4 text-lg text-[#45423C]"><CalendarCheck className="h-6 w-6 text-[#6F6A60]" /> {el ? "Αίτηση άδειας" : "Leave request"}</Link>}
        {can("/payslips") && <Link to="/payslips" data-testid="staff-payslips" className="flex items-center gap-3 px-5 py-4 text-lg text-[#45423C]"><FileText className="h-6 w-6 text-[#6F6A60]" /> {el ? "Οι αποδείξεις μου" : "My payslips"}</Link>}
        <button onClick={toggle} data-testid="staff-lang" className="w-full flex items-center gap-3 px-5 py-4 text-lg text-[#45423C]"><Languages className="h-6 w-6 text-[#6F6A60]" /> {el ? "Γλώσσα: Ελληνικά → English" : "Language: English → Ελληνικά"}</button>
        <button onClick={logout} data-testid="staff-logout" className="w-full flex items-center gap-3 px-5 py-4 text-lg text-[#991B1B]"><LogOut className="h-6 w-6" /> {el ? "Αποσύνδεση" : "Logout"}</button>
      </div>
    </div>
  );
}
